export default __webpack_public_path__ + "static/media/logo-full.debd7855.svg";